import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "field"]

    declare checkboxTarget: HTMLInputElement
    declare fieldTarget: HTMLInputElement

    connect() {
        this.toggle()
    }

    toggle() {
        this.fieldTarget.disabled = this.checkboxTarget.checked
    }
}
